<script setup>
import { onMounted } from "vue";

onMounted(() => {
  const shareButton = document.getElementById("shareButton");
  if (navigator.share) {
    // Enable the Web Share API button
    shareButton.addEventListener("click", () => {
      navigator
        .share({
          title: "DJ Saturn Links",
          text: "Check out DJ Saturn's Social Media Links!",
          url: "https://www.djsaturn.com/links",
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => console.error("Sharing failed:", error));
    });
  } else {
    // If Web Share API is not supported, hide the button
    shareButton.classList.add("d-none");
  }
});

function trackEvent(event) {
  if (import.meta.env.MODE == "production") {
    window._paq.push(["trackEvent", "link", event]);
  }

  return true;
}
</script>

<template>
  <div class="links-page">
    <div class="container py-4 py-md-5">
      <!-- Logo -->
      <div class="text-center mb-4">
        <img
          class="img-fluid d-block mx-auto links-logo"
          src="/assets/images/djsaturn-logo.svg"
          alt="DJ Saturn"
        />

        <p class="links-tagline text-white-50 mt-3 mb-0">
          DJ • Music • Live Streams
        </p>
      </div>

      <!-- Share -->
      <div class="text-center mb-4">
        <button
          type="button"
          id="shareButton"
          class="btn btn-outline-light share-button"
          aria-label="Share DJ Saturn"
          @click="sharePage"
        >
          <i class="bi bi-share-fill"></i>
        </button>
      </div>

      <!-- Links -->
      <div class="links-list mx-auto">
        <router-link
          :to="{ name: 'home' }"
          class="btn btn-outline-light link-button"
          @click="trackEvent('homepage-links')"
        >
          <i class="bi bi-house-door-fill link-icon"></i>

          <span>djsaturn.com</span>
        </router-link>

        <a
          class="btn btn-outline-light link-button"
          href="https://www.twitch.tv/djsaturn_"
          target="_blank"
          rel="noopener"
          @click="trackEvent('twitch-links')"
        >
          <i class="bi bi-twitch link-icon"></i>

          <span>Twitch</span>
        </a>

        <a
          class="btn btn-outline-light link-button"
          href="https://www.tiktok.com/@djsaturn_"
          target="_blank"
          rel="noopener"
          @click="trackEvent('tiktok-links')"
        >
          <i class="bi bi-tiktok link-icon"></i>

          <span>TikTok</span>
        </a>

        <a
          class="btn btn-outline-light link-button"
          href="https://www.instagram.com/djs4turn"
          target="_blank"
          rel="noopener"
          @click="trackEvent('instagram-links')"
        >
          <i class="bi bi-instagram link-icon"></i>

          <span>Instagram</span>
        </a>

        <a
          class="btn btn-outline-light link-button"
          href="https://www.youtube.com/@djs4turn"
          target="_blank"
          rel="noopener"
          @click="trackEvent('youtube-links')"
        >
          <i class="bi bi-youtube link-icon"></i>

          <span>YouTube</span>
        </a>
      </div>
    </div>
  </div>
</template>
<style scoped>
.links-page {
  min-height: 100vh;
}

.links-logo {
  width: 100%;
  max-width: 380px;
}

.links-tagline {
  font-size: 0.95rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.links-list {
  width: 100%;
  max-width: 620px;

  display: grid;
  gap: 1rem;
}

.link-button {
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 64px;

  padding: 0.75rem 4rem;

  font-size: 1.25rem;
  font-weight: 700;

  border-width: 2px;
  border-radius: 0.75rem;

  transition: transform 0.2s ease, box-shadow 0.2s ease,
    background-color 0.2s ease;
}

.link-icon {
  position: absolute;
  left: 1.25rem;

  width: 32px;

  font-size: 1.35rem;
  text-align: center;
}

.link-button:hover {
  transform: translateY(-2px);

  box-shadow: 0 8px 25px rgba(255, 255, 255, 0.12);
}

.share-button {
  width: 48px;
  height: 48px;

  padding: 0;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  font-size: 1.1rem;
}

@media (max-width: 575.98px) {
  .links-logo {
    max-width: 280px;
  }

  .link-button {
    min-height: 58px;

    padding-left: 3.5rem;
    padding-right: 3.5rem;

    font-size: 1.1rem;
  }

  .link-icon {
    left: 1rem;
  }
}
</style>
